import { MenuItem } from 'src/app/pages/restaurants/shared/models/menu-item.model';

export class CartItem{

    constructor(public menuItem:MenuItem,public qtd:number=1){}

    public value():number{
        return this.menuItem.price*this.qtd;
    }
}